var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Essentional, UI / Cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9999 8.16235V8.23488C21.9999 9.09562 21.9999 9.52599 21.7927 9.87811C21.5855 10.2302 21.2093 10.4392 20.4569 10.8572L19.6636 11.298C20.2102 9.44985 20.3926 7.46415 20.4601 5.76598C20.4629 5.69317 20.4662 5.61946 20.4695 5.54498L20.4718 5.4928C21.1231 5.71897 21.4887 5.88759 21.7168 6.20409C22 6.59693 22 7.11874 21.9999 8.16235Z",
    fill: "#F7CE45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 8.16233V8.23486C2.00003 9.0956 2.00004 9.52597 2.20723 9.87809C2.41442 10.2302 2.79063 10.4392 3.54305 10.8572L4.33681 11.2982C3.79007 9.45 3.60767 7.46421 3.54025 5.76596C3.53736 5.69315 3.5341 5.61944 3.53081 5.54496L3.5285 5.49265C2.87701 5.71889 2.51126 5.88751 2.2831 6.20407C1.99996 6.59691 1.99997 7.11872 2 8.16233Z",
    fill: "#F7CE45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3771 2.34674C15.2531 2.15709 13.7837 2 12.0002 2C10.2166 2 8.74724 2.15709 7.62318 2.34674C6.48445 2.53887 5.91508 2.63494 5.43937 3.22083C4.96365 3.80673 4.98879 4.43998 5.03907 5.70647C5.21169 10.0544 6.14996 15.4851 11.25 15.9657V19.5H9.8198C9.34312 19.5 8.93271 19.8365 8.83922 20.3039L8.65 21.25H6C5.58579 21.25 5.25 21.5858 5.25 22C5.25 22.4142 5.58579 22.75 6 22.75H18C18.4142 22.75 18.75 22.4142 18.75 22C18.75 21.5858 18.4142 21.25 18 21.25H15.35L15.1608 20.3039C15.0673 19.8365 14.6569 19.5 14.1802 19.5H12.75V15.9657C17.8503 15.4853 18.7886 10.0545 18.9612 5.70647C19.0115 4.43998 19.0367 3.80673 18.5609 3.22083C18.0852 2.63494 17.5159 2.53887 16.3771 2.34674Z",
    fill: "#F7CE45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingIcon);
export default __webpack_public_path__ + "static/media/rankingIcon.7eb6eb744298743b4ef196ed761f01d1.svg";
export { ForwardRef as ReactComponent };